import { defineStore } from "pinia";
import { computed, reactive, watch } from "vue";
import { debounce } from 'lodash';

export const useLocaleStore = defineStore('locale', () => {
  const config = reactive({
    locale: 'de'
  })

  const localeInStorage = localStorage.getItem('locale')
  if (localeInStorage) {
    const { locale } = JSON.parse(localeInStorage)
    config.locale = locale
  }

  const inEnglish = computed(() => config.locale === 'en')

  watch(() => config, (state) => {
    storeLocale(state)
  })

  const storeLocale = debounce((state) => {
    localStorage.setItem('locale', JSON.stringify(state))
  }, 250)

  return {
    config,
    inEnglish
  }
})